module.exports = __webpack_public_path__ + "fc8a2b48ae523377a181be3813d58c31.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/fonts/ui-grid.ttf
// module id = 928
// module chunks = 1